import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, withRouter } from 'react-router-dom';
import { CenterMediumContent, FlexRow, MediumText, PaperBlock, Spinner } from '@guryou/html-components';
import { reactivateUserAccount, stateError, stateIsLoaded } from '@guryou/redux';
import './main.css';

const ReactivateAccount = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { email, code } = useParams();

  const reactivate = useSelector(state => state.user.reactivate);

  useEffect(() => {
    dispatch(reactivateUserAccount(email, code));
  }, [code, dispatch, email]);

  return (
    <CenterMediumContent isPublicContent={false}>
      <PaperBlock marginTop={5} display="flex" flexWrap="wrap" flexDirection="row" justifyContent="center">
        <div className="logoBg"></div>
        {stateError(reactivate) ? (
          <MediumText color="red">{reactivate?.error?.message}</MediumText>
        ) : !stateIsLoaded(reactivate) ? (
          <FlexRow>
            <Spinner />
            <MediumText>{t('ACCOUNT.pleaseWaitReactivatingAccount')}</MediumText>
          </FlexRow>
        ) : (
          <MediumText>{t('ACCOUNT.yourAccountIsActiveWelcomeBack')}</MediumText>
        )}
      </PaperBlock>
    </CenterMediumContent>
  );
};

export default withRouter(ReactivateAccount);
